import {BaseTrackingEvent} from '@udemy-v2/event-tracking';

/**
 * Fired when a preview video starts playing
 */
export class PreviewVideoPlayEvent implements BaseTrackingEvent {
    _type = 'PreviewVideoPlayEvent';
    courseId: number;
    buyableTrackingId: string | undefined;
    previewId: number;
    offset: number;
    nonInteraction: boolean;
    uiRegion: string | undefined;

    constructor({
        courseId,
        buyableTrackingId,
        previewId,
        offset = 0,
        nonInteraction = false,
        uiRegion,
    }: {
        courseId: number;
        buyableTrackingId: string | undefined;
        previewId: number;
        offset?: number;
        nonInteraction?: boolean;
        uiRegion: string | undefined;
    }) {
        this.courseId = courseId;
        this.buyableTrackingId = buyableTrackingId;
        this.previewId = previewId;
        this.offset = offset;
        this.nonInteraction = nonInteraction;
        this.uiRegion = uiRegion;
    }
}

/**
 * Fired when a preview video is viewed/displayed
 */
export class PreviewVideoViewEvent implements BaseTrackingEvent {
    _type = 'PreviewVideoViewEvent';
    courseId: number;
    buyableTrackingId: string | undefined;
    previewId: number;
    uiRegion: string | undefined;

    constructor({
        courseId,
        buyableTrackingId,
        previewId,
        uiRegion,
    }: {
        courseId: number;
        buyableTrackingId: string | undefined;
        previewId: number;
        uiRegion: string | undefined;
    }) {
        this.courseId = courseId;
        this.buyableTrackingId = buyableTrackingId;
        this.previewId = previewId;
        this.uiRegion = uiRegion;
    }
}
